module.exports = __webpack_public_path__ + "static/kfg-f4110f9c823e394363364d229a365152.svg";